import { $color_grey_9, $color_grey_5, $color_grey_6, $color_grey_4, $color_grey_2, $color_grey_8, $color_grey_7 } from '../pebbleGlobalToken/color.js';

/**
 * 数字输入框-最深的文本色。为了符合W3C标准，默认的文本颜色使用了该色，同时这个颜色也是最深的中性色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $input_number_color_text = $color_grey_9;

/**
 * 数字输入框-默认使用的边框颜色, 用于分割不同的元素，例如：表单的分割线、卡片的分割线等。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $input_number_color_border = $color_grey_5;

/**
 * 数字输入框-控制输入组件的外轮廓线宽度。
 * @description enDesc: -
 * @description type: Border
 * @description value: 0
 */
var $input_number_control_outline_width = 0;

/**
 * 数字输入框-较小的组件高度
 * @description enDesc: -
 * @description type: Font
 * @description value: 28
 */
var $input_number_control_height_sm = 28;

/**
 * 数字输入框-	控制禁用状态下的字体颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-6
 */
var $input_number_color_text_disabled = $color_grey_6;

/**
 * 数字输入框-	在禁用状态下的边框色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $input_number_color_border_disabled = $color_grey_4;
/**
 * 数字输入框-	控制容器在禁用状态下的背景色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $input_number_color_bg_container_disabled = $color_grey_2;

/**
 * 数字输入框-	品牌色是体现产品特性和传播理念最直观的视觉元素之一。在你完成品牌主色的选取之后，我们会自动帮你生成一套完整的色板，并赋予它们有效的设计语义s
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-8
 */
var $input_number_color_primary = $color_grey_8;

/**
 * 数字输入框-操作区按钮背景色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $input_number_handler_bg_hover = $color_grey_2;

/**
 * 数字输入框-hover状态下的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $input_number_color_hover = $color_grey_5;

/**
 * 数字输入框-hover状态下的边框颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-8
 */
var $input_number_color_border_hover = $color_grey_8;

/**
 * 数字输入框-选中状态下的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $input_number_color_active = $color_grey_9;

/**
 * 数字输入框-选中状态下的边框颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $input_number_color_border_active = $color_grey_9;

/**
 * 数字输入框-只读状态下的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-7
 */
var $input_number_color_readonly = $color_grey_7;

/**
 * 数字输入框-错误状态下的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $input_number_color_error = $color_grey_5;
var $input_number_addon_bg = $color_grey_2;

export { $input_number_addon_bg, $input_number_color_active, $input_number_color_bg_container_disabled, $input_number_color_border, $input_number_color_border_active, $input_number_color_border_disabled, $input_number_color_border_hover, $input_number_color_error, $input_number_color_hover, $input_number_color_primary, $input_number_color_readonly, $input_number_color_text, $input_number_color_text_disabled, $input_number_control_height_sm, $input_number_control_outline_width, $input_number_handler_bg_hover };
